export const STATIC_PAGES_PHRASES = {
    CALIFORNIA_PRIVACY_TITLE: 16654,
    CALIFORNIA_PRIVACY_CONTENT: 16655,
    PRIVACY_POLICY_TITLE: 16658,
    PRIVACY_POLICY_CONTENT: 16664,
    TERMS_AND_CONDITIONS_TITLE: 16666,
    TERMS_AND_CONDITIONS_CONTENT: 16667,
    COMPENSATION_PROVISIONS_TITLE: 16668,
    COMPENSATION_PROVISIONS_CONTENT: 16669,
    COOKIE_POLICY_TITLE: 16670,
    COOKIE_POLICY_CONTENT: 16671,
    ABOUT_US_TITLE: 16672,
    ABOUT_US_CONTENT: 16673,
    CONTACT_US_TITLE: 16717,
    CONTACT_US_CONTENT: 16718,
    REQUEST_SUPPORT_BUTTON: 1880,
    YOTI_TITLE: 16809,
    YOTI_CONTENT: 16810,
    SCREENING_TITLE: 3207,
    SCREENING_CONTENT: 16895,
    TAX_FAQ_TITLE: 17692,
    TAX_FAQ_CONTENT: 17693,
} as const;
